import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import { wishlistMessages } from '../messages';

import { H3, LinkLabel, ModalBody } from './styled';
import { WishlistLink } from './WishlistLink';

interface IModalProps {
  hostUrl: string;
  anonymousId: string;
  isCopySuccessful: boolean;
}

export const Modal: React.FC<IModalProps> = ({
  anonymousId,
  isCopySuccessful,
  hostUrl,
}) => {
  return (
    <ModalBody>
      <H3>
        <FormattedMessage {...wishlistMessages.header} />
      </H3>

      <LinkLabel htmlFor="wishlist-link">
        <FormattedMessage {...wishlistMessages.shareLabel} />
      </LinkLabel>
      <br />
      <WishlistLink
        hostUrl={hostUrl}
        anonymousId={anonymousId}
        isCopySuccessful={isCopySuccessful}
      />
    </ModalBody>
  );
};
